import {consoleLogger} from '@gongxigames/framework/core/fragments/ConsoleLogger';

export interface IStorage {
    getItem(key: string): string | null;
    setItem(key: string, value: string): void;
    removeItem(key: string): void;
}

export class LocalStorage implements IStorage{
    private readonly _storage!: Storage;

    constructor() {
        try {
            this._storage = window.localStorage;
        } catch (e) {
            consoleLogger.warn('localStorage is not supported!');
        }
    }

    public getItem(key: string): string | null {
        return this._storage?.getItem(key) ?? null;
    }

    public setItem(key: string, value: string): void {
        this._storage && this._storage.setItem(key, value);
    }

    public removeItem(key: string): void {
        this._storage && this._storage.removeItem(key);
    }
}

export const storage = new LocalStorage();
